export const isFeatureEnabledSafe = (abtProvider, gateName) => {
  try {
    return abtProvider.isFeatureEnabled(gateName) ?? false
  } catch (err) {
    console.error(err)

    return false
  }
}
